<template>
    <div>
        <div style="float: left">
            <el-input placeholder="请输入名称" v-model="queryParams.keywods" prefix-icon="el-icon-search"
                      style="width: 250px"></el-input>
            <el-button style="margin-left: 10px" type="danger" @click="searchTask">搜索</el-button>
        </div>
        <div class="preview-opration">
            <el-button style="margin-left: 30px" icon="el-icon-plus" type="danger" @click="openCreateTaskDialog">新增任务
            </el-button>
        </div>
        <div class="email-list">
            <el-table class="email-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="taskList" :row-key="() => Math.random()">
                <el-table-column prop="batchNumber" label="批次号"></el-table-column>
                <el-table-column prop="emailTheme" label="主题"></el-table-column>
                <el-table-column prop="emailContent" label="内容" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span>{{scope.row.taskStatus | formatStatus}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createdTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" @click="seeTaskData(scope.row)">查看
                        </el-button>
                        <el-button type="danger" icon="el-icon-delete" @click="handleRemove(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog title="增加任务" :visible.sync="dialogVisible" width="40%" @close="clearData"
                   :close-on-click-modal="false">
            <div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">主题名称</span>
                    <el-input maxlength="30" style="width: 70%" size="small" v-model="taskData.emailTheme"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 48px">内容</span>
                    <el-input type="textarea" style="width: 70%" :rows="10" placeholder="请输入内容"
                              v-model="taskData.emailContent">
                    </el-input>
                </div>
                <div style="margin-top: 20px">
                    <div>
                        <el-upload
                                ref="upload"
                                action="/admin/batch/email/create"
                                :data="taskData"
                                :headers="{'Authorization': token}"
                                :on-success="handleSuccess"
                                :on-error="handError"
                                :on-exceed="fileOnExceed"
                                accept=".xls,.xlsx"
                                :limit="1"
                                :auto-upload="false">
                            <div style="margin-top: 20px">
                                <el-button slot="trigger" size="small" type="primary">导入人员</el-button>
                                <span style="padding-left: 50px;color: red" slot="tip" class="el-upload__tip">只能上传.xls/.xlsx文件</span>
                            </div>
                        </el-upload>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="createTask">确 定</el-button>
            </span>

            <div v-if="failList.length>0" style="margin-top: 20px">
                <div style="color: red;height: 50px;line-height: 50px">导入失败的数据</div>
                <el-table class="email-table" max-height="250" border
                          :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                          :data="failList" :row-key="() => Math.random()">
                    <el-table-column prop="userName" label="用户名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="userEmail" label="用户邮箱" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="batchNumber" label="失败原因" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import userInfoHelper from 'common/userInfo';

    export default {
        name: 'Task',
        data() {
            return {
                taskList: [], //任务列表
                total: 0, //总条数
                queryParams: { //查询参数
                    page: 1,
                    size: 10,
                    status: '',
                    keywods: '',
                    batchNumber: ''
                },
                dialogVisible: false, //对话框是否显示
                taskData: {emailTheme: '', emailContent: ''},
                token: userInfoHelper.get().accessToken,
                loading: false,
                failList: []
            };
        },
        filters: {
            formatStatus(state) {
                switch (state) {
                    case 0:
                        return "未发送";
                    case 1:
                        return "已发送";
                    case 2:
                        return "发送失败";
                }
            }
        },
        methods: {
            getBatchSendEmailTask(query) {
                api.getBatchSendEmailTask(query).then(({data}) => {
                    this.taskList = data.list;
                    this.total = data.totalCount;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getBatchSendEmailTask(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getBatchSendEmailTask(this.queryParams);
            },
            seeTaskData(row) {
                this.$router.push({
                    path: '/home/batch/email/detail',
                    query: {batchNum: row.batchNumber}
                });
            },
            searchTask() {
                this.getBatchSendEmailTask(this.queryParams);
            },
            createTask() {
                if (this.taskData.emailTheme == "") {
                    this.$message.error('邮件主题不能为空');
                    return;
                }
                if (this.taskData.emailContent == "") {
                    this.$message.error('邮件内容不能为空');
                    return;
                }
                this.loading = true;
                this.$refs.upload.submit();
            },
            handleSuccess(data) {
                console.log(data)
                this.$message.error(data.msg);
                this.failList = data.data;
                //上传成功
                this.getBatchSendEmailTask(this.queryParams);
                this.loading = false;
            },
            handError() {
                this.$message.error('创建失败！');
                this.$refs['upload'].clearFiles();
                this.loading = false;
            },
            fileOnExceed() {
                this.$message('文件最大上传为1');
            },
            openCreateTaskDialog() {
                this.dialogVisible = true;
            },
            handleRemove(id) {
                this.$confirm('确认删除此任务吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteBatchSendEmailTask({"id": id}).then(({data}) => {
                        this.$message.success('删除成功！');
                        this.getBatchSendEmailTask(this.queryParams);
                    });
                }).catch(() => {
                });
            },
            clearData() {
                this.$refs['upload'].clearFiles();
                this.failList = [];
                this.taskData = {emailTheme: '', emailContent: ''};
            }
        },
        created() {
            this.getBatchSendEmailTask(this.queryParams);
        }
    };
</script>

<style lang="less" scoped>
    .preview-opration {
        float: right;
    }

    .email-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .email-table {
            margin-top: 30px;
        }
    }
</style>
